export default __webpack_public_path__ + "static/media/nebula.b284ae1e.jpg";